import request from "./request";

export async function getSystem() {
  const resp = await request()
    .get("/system")
    .then(resp => resp.data);
  return resp;
}

export async function updateSystem(systemObj) {
  const resp = await request()
    .post(`/system/update`, systemObj)
    .then(resp => resp.data);
  return resp;
}
